import { render, staticRenderFns } from "./CiAttachment.vue?vue&type=template&id=6ffd6086&"
import script from "./CiAttachment.vue?vue&type=script&lang=js&"
export * from "./CiAttachment.vue?vue&type=script&lang=js&"
import style0 from "./CiAttachment.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports